(function () {
  'use strict';

  // ─── 分岐ロジック（変動指示書に従う） ───────────────────────────
  const FLOW = {
    1: { yes: 2,             no: 3 },
    2: { yes: 6,             no: 7 },
    3: { yes: 5,             no: 4 },
    4: { yes: 'cassis-basil',no: 'no3' },
    5: { yes: 'no1',         no: 7 },
    6: { yes: 'rose',        no: 4 },
    7: { yes: 'magnolia',    no: 8 },
    8: { yes: 'jasmine',     no: 'no2' },
  };

  const FADE_DURATION = 300; // ms

  // ─── DOM 参照 ─────────────────────────────────────────────────
  const quizSection   = document.getElementById('diagnosisQuiz');
  const backBtn       = document.getElementById('diagnosisBack');
  const retryBtns     = document.querySelectorAll('.js-diagnosis-retry');

  // 状態管理
  let historyStack = [];  // 遷移履歴
  let current = { type: 'question', id: 1 };

  // ─── ユーティリティ ────────────────────────────────────────────
  function getEl(state) {
    if (state.type === 'question') {
      return document.querySelector(`.p-diagnosis__question[data-question="${state.id}"]`);
    }
    return document.getElementById('result-' + state.id);
  }

  function fadeOut(el, cb) {
    el.classList.add('is-exiting');
    setTimeout(function () {
      el.classList.remove('is-visible', 'is-exiting');
      el.classList.add('is-hidden');
      if (cb) cb();
    }, FADE_DURATION);
  }

  function fadeIn(el) {
    el.classList.remove('is-hidden');
    // 次フレームで is-visible を付けてトランジションを発火
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-visible');
      });
    });
  }

  function updateBackBtn() {
    backBtn.style.visibility = historyStack.length > 0 ? 'visible' : 'hidden';
  }

  // ─── 遷移 ──────────────────────────────────────────────────────
  function goTo(nextState) {
    const currentEl = getEl(current);
    const nextEl    = getEl(nextState);
    if (!nextEl) return;

    fadeOut(currentEl, function () {
      // 結果 ↔ クイズ のセクション切り替え
      if (nextState.type === 'result') {
        quizSection.classList.add('is-hidden');
        nextEl.classList.remove('is-hidden');
        fadeIn(nextEl);
      } else {
        quizSection.classList.remove('is-hidden');
        fadeIn(nextEl);
      }

      historyStack.push(current);
      current = nextState;
      updateBackBtn();
      window.scrollTo({ top: quizSection.closest('.c-section').offsetTop - 20, behavior: 'smooth' });
    });
  }

  function goBack() {
    if (historyStack.length === 0) return;

    const prevState = historyStack.pop();
    const currentEl = getEl(current);
    const prevEl    = getEl(prevState);

    fadeOut(currentEl, function () {
      if (current.type === 'result') {
        quizSection.classList.remove('is-hidden');
      }
      if (prevState.type === 'question') {
        quizSection.classList.remove('is-hidden');
      }
      fadeIn(prevEl);
      current = prevState;
      updateBackBtn();
      window.scrollTo({ top: quizSection.closest('.c-section').offsetTop - 20, behavior: 'smooth' });
    });
  }

  function reset() {
    const currentEl = getEl(current);
    fadeOut(currentEl, function () {
      if (current.type === 'result') {
        quizSection.classList.remove('is-hidden');
      }
      historyStack = [];
      current = { type: 'question', id: 1 };
      const firstQ = document.querySelector('.p-diagnosis__question[data-question="1"]');
      fadeIn(firstQ);
      updateBackBtn();
      window.scrollTo({ top: quizSection.closest('.c-section').offsetTop - 20, behavior: 'smooth' });
    });
  }

  // ─── 初期化 ───────────────────────────────────────────────────
  function init() {
    // 全質問を非表示にしてから Q1 のみ表示
    document.querySelectorAll('.p-diagnosis__question').forEach(function (q) {
      q.classList.add('is-hidden');
    });
    document.querySelectorAll('.p-diagnosis__result').forEach(function (r) {
      r.classList.add('is-hidden');
    });

    var firstQ = document.querySelector('.p-diagnosis__question[data-question="1"]');
    if (firstQ) firstQ.classList.replace('is-hidden', 'is-visible');

    updateBackBtn();

    // 回答ボタン
    document.querySelectorAll('.p-diagnosis__answer-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var answer     = this.dataset.answer;
        var questionEl = this.closest('.p-diagnosis__question');
        var qId        = parseInt(questionEl.dataset.question, 10);
        var next       = FLOW[qId][answer];

        goTo(typeof next === 'number'
          ? { type: 'question', id: next }
          : { type: 'result',   id: next }
        );
      });
    });

    // 戻るボタン（クイズ内）
    backBtn.addEventListener('click', goBack);

    // 戻るボタン（結果ページ）
    document.querySelectorAll('.js-diagnosis-back').forEach(function (btn) {
      btn.addEventListener('click', goBack);
    });

    // 迷っているあなたへ（他オイルの結果へ内部遷移）
    document.querySelectorAll('.js-diagnosis-goto').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var resultId = this.dataset.result;
        goTo({ type: 'result', id: resultId });
      });
    });

    // もう一度診断するボタン（結果ページ）
    retryBtns.forEach(function (btn) {
      btn.addEventListener('click', reset);
    });
    // ※ シェアボタンは末尾の initShareButtons() IIFE で処理
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ─── SP 下部追従 購入バー ─────────────────────────────────────────
(function () {
  'use strict';

  function isSP() {
    return window.innerWidth <= 767;
  }

  function initStickyBars() {
    if (!isSP()) return;

    // .p-diagnosis に追加することで .c-section の em スケールを継承させる
    var pDiagnosis = document.querySelector('.p-diagnosis');
    if (!pDiagnosis) return;

    var bars = [];

    document.querySelectorAll('.p-diagnosis__result').forEach(function (result) {
      var usageGrid    = result.querySelector('.p-diagnosis__result-usage-grid');
      var resultOthers = result.querySelector('.p-diagnosis__result-others');
      var sizesBottom  = result.querySelector('.p-diagnosis__result-sizes-bottom');

      if (!usageGrid || !resultOthers || !sizesBottom) return;

      // SP: sizes-bottom と直前ラベルを非表示
      sizesBottom.style.display = 'none';
      var prevEl = sizesBottom.previousElementSibling;
      if (prevEl && prevEl.classList.contains('p-diagnosis__result-size-label')) {
        prevEl.style.display = 'none';
      }

      // sticky バーを生成してボタンを複製
      var bar = document.createElement('div');
      bar.className = 'p-diagnosis__result-sticky-bar';
      sizesBottom.querySelectorAll('.p-diagnosis__result-size-btn').forEach(function (btn) {
        bar.appendChild(btn.cloneNode(true));
      });
      pDiagnosis.appendChild(bar);

      bars.push({ bar: bar, result: result, usageGrid: usageGrid, resultOthers: resultOthers });
    });

    if (bars.length === 0) return;

    function onScroll() {
      var vph = window.innerHeight;
      bars.forEach(function (item) {
        // 結果が非表示なら即時隠す（クイズ中・他の結果）
        if (item.result.classList.contains('is-hidden')) {
          item.bar.classList.remove('is-active');
          return;
        }
        var usageBottom = item.usageGrid.getBoundingClientRect().bottom;
        var othersTop   = item.resultOthers.getBoundingClientRect().top;
        // usage-grid の下端が画面上半分より上に来たら表示開始
        // result-others が画面内に入ったら非表示
        var show = usageBottom < vph * 0.5 && othersTop > vph;
        item.bar.classList.toggle('is-active', show);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // 初期チェック
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBars);
  } else {
    initStickyBars();
  }
})();

// ─── URL パラメータ結果直接表示 ──────────────────────────────────
// ?result=no1 のようなパラメータ付き URL でアクセスしたとき、
// クイズをスキップして該当結果を直接表示する。
(function () {
  'use strict';

  function initFromUrl() {
    var resultId = new URLSearchParams(location.search).get('result');
    if (!resultId) return;

    var targetEl = document.getElementById('result-' + resultId);
    if (!targetEl) return;

    // クイズセクションを非表示
    var quiz = document.getElementById('diagnosisQuiz');
    if (quiz) quiz.classList.add('is-hidden');

    // 全結果を非表示にしてから対象のみ表示
    document.querySelectorAll('.p-diagnosis__result').forEach(function (r) {
      r.classList.add('is-hidden');
    });
    targetEl.classList.remove('is-hidden');
    targetEl.classList.add('is-visible');

    // ページトップへスクロール
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFromUrl);
  } else {
    initFromUrl();
  }
})();

// ─── シェアボタン（?result=xxx 付き URL を共有）─────────────────
(function () {
  'use strict';

  function showToast(msg) {
    var toast = document.createElement('div');
    toast.textContent = msg;
    toast.style.cssText =
      'position:fixed;bottom:5em;left:50%;transform:translateX(-50%);' +
      'background:#000;color:#fff;padding:.6em 1.6em;border-radius:2em;' +
      'font-size:13px;z-index:9999;pointer-events:none;white-space:nowrap;';
    document.body.appendChild(toast);
    setTimeout(function () { document.body.removeChild(toast); }, 2000);
  }

  function copyUrl(url) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(function () { showToast('URLをコピーしました'); })
        .catch(function () { window.prompt('URLをコピーしてシェアしてください', url); });
    } else {
      window.prompt('URLをコピーしてシェアしてください', url);
    }
  }

  function initShareButtons() {
    document.querySelectorAll('.p-diagnosis__result-share-icon').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();

        var resultEl = btn.closest('.p-diagnosis__result');
        if (!resultEl) return;

        var resultId = resultEl.id.replace('result-', '');
        var nameEl   = resultEl.querySelector('.p-diagnosis__result-name');
        var name     = nameEl ? nameEl.textContent.trim() : '';
        var shareUrl = location.origin + location.pathname + '?result=' + resultId;
        var label    = btn.getAttribute('aria-label') || '';

        if (label.indexOf('X') !== -1) {
          // X (Twitter) シェア
          window.open(
            'https://x.com/intent/tweet' +
            '?url=' + encodeURIComponent(shareUrl) +
            '&text=' + encodeURIComponent('track Oil ' + name + ' #JoelRoty'),
            '_blank', 'noopener,noreferrer'
          );
        } else if (label.indexOf('Facebook') !== -1) {
          // Facebook シェア
          window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(shareUrl),
            '_blank', 'noopener,noreferrer'
          );
        } else if (label.indexOf('LINE') !== -1) {
          // LINE シェア
          window.open(
            'https://social-plugins.line.me/lineit/share?url=' + encodeURIComponent(shareUrl),
            '_blank', 'noopener,noreferrer'
          );
        } else {
          copyUrl(shareUrl);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareButtons);
  } else {
    initShareButtons();
  }
})();

// ─── 迷っているあなたへ：SP で SimpleBar のスクロールバーを常時表示 ───────
// 結果は非表示（display:none）の状態で読み込まれるため、表示されたタイミングで初期化・再計算する
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 767px)');

  function setupScrollbar(result) {
    if (!mq.matches || typeof SimpleBar === 'undefined') return;
    if (result.classList.contains('is-hidden')) return;

    var list = result.querySelector('.p-diagnosis__result-others-list');
    if (!list) return;

    var instance = SimpleBar.instances.get(list);
    if (instance) {
      instance.recalculate();
    } else {
      new SimpleBar(list, { autoHide: false });
    }
  }

  function initOthersScrollbar() {
    var results = document.querySelectorAll('.p-diagnosis__result');

    results.forEach(function (result) {
      setupScrollbar(result);

      new MutationObserver(function () {
        setupScrollbar(result);
      }).observe(result, { attributes: true, attributeFilter: ['class'] });
    });

    // PC → SP へ切り替わった場合も初期化
    mq.addEventListener('change', function () {
      results.forEach(setupScrollbar);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOthersScrollbar);
  } else {
    initOthersScrollbar();
  }
})();
